//useGlobalFunctions.js

/**
 * FIREBASE
 */

export const isFirebaseStorageURL = (imageUrl) => {
        // Check if imageUrl is null or undefined
        if (!imageUrl) {
            return false; // Return false if imageUrl is null or undefined
          }
        
          const firebaseStorageKeywords = [
            "firebasestorage.googleapis.com",
            "o/",
            "alt=media",
            "token=",
          ];
        
          // Check if all the Firebase Storage keywords are present in the URL
          return firebaseStorageKeywords.every(keyword => imageUrl.includes(keyword));
  };
  
export const getDomainWithHttps = () => {
      const protocol = window.location.protocol; // Example: "http:" or "https:"
      const hostname = window.location.hostname; // Example: "www.example.com" or "localhost"
      const port = window.location.port; // Example: "8080"
    
      const domainWithHttps = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
      return domainWithHttps;
};

//////////////////////////////////